// Styles
require("./environment-warn.scss");

// JavaScript
var $ = require("jquery");
var $body = $('body');
var displayAttributeValue = $body.attr("data-environment-display");
var shouldDisplayWarning = displayAttributeValue == "true" || displayAttributeValue == "True";

if (shouldDisplayWarning) {
    var environment = $body.attr("data-environment");
    require.ensure(["./environment-warn.js"], function () {
        var Warning = require("./environment-warn.js");
        new Warning(environment);
    });
}


// WEBPACK FOOTER //
// ./Sig.Web/src/common/com-environment-warn/com-environment-warn.chunk.js